// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modified */
.views-container {
	display: table-cell;
	max-width: 320px;
	min-width: 320px;
}

@media screen and (max-width: 1240px) {
	.views-container {
		max-width: 195px;
		min-width: 195px;
	}
}

.views {
	position: relative;
	width: 100%; 
	margin-top: 48px;
	padding: 0;	
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	border-top: 1px solid #d5d5d5;
	border-right: 1px solid #d5d5d5;
	border-bottom: 1px solid #d5d5d5;
} 

.views-options {
	margin: 0 auto;
	/*padding: 0;*/
	text-align: center;
}

.views-options > li{
	display: inherit;
	margin: 0;
	padding: 0 10px !important;
	font-size: 25px;
	list-style: none;
	text-align: center;
	height: 29px;
}

@media screen and (max-width: 1240px) {
    .views-container {
        max-width: 260px;
        min-width: 260px;
    }

    .views-options li {
        padding: 0 2px !important;
    }
}

.views-options li a, .views-options li a .fa:not(.goalHelpItem) {
	color: #555 !important;
	-webkit-transition: color 300ms ease-out;
	    -moz-transition: color 300ms ease-out;
	    -o-transition: color 300ms ease-out;
		transition: color 300ms ease-out;
		padding: 0 !important;	
}

.views-options li>a:hover,
.views-options li>a:hover .fa,
.views-options li>div a:hover,
.views-options li>div a:hover .fa {
	cursor: pointer;
	color: #cc7929 !important;
	text-decoration:none;
	-webkit-transition: color 300ms ease-out;
	    -moz-transition: color 300ms ease-out;
	    -o-transition: color 300ms ease-out;
	    transition: color 300ms ease-out;
}

.views-options li a.active, .views-options li a.active .fa {
	color: #cc7929 !important;
}

.views-options li a.active i {
/*	text-shadow: 1px 1px 5px rgba(0,0,0,0.3);*/
}


.custom-autocomplete {
    max-height: 100px;
    overflow-y: auto;   /* prevent horizontal scrollbar */
    overflow-x: hidden; /* add padding to account for vertical scrollbar */
    z-index:1000 !important;
}

.custom-combobox {
  position: relative;
  display: inline-block;
}

.custom-combobox-toggle {
  position: absolute;
  top: 0;
  bottom: 0;
  margin-left: -1px;
  padding: 0;
}

.custom-combobox-input {
  margin: 0;
  padding: 5px 10px;
  width: 48px;
}	 `, "",{"version":3,"sources":["webpack://./assets/style/partials/views.css"],"names":[],"mappings":"AAAA,aAAa;AACb;CACC,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC;EACC,gBAAgB;EAChB,gBAAgB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,UAAU;CACV,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;CAC/H,6BAA6B;CAC7B,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;AACb;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;CACC,sBAAsB;CACtB,wCAAwC;KACpC,qCAAqC;KACrC,mCAAmC;EACtC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;;;CAIC,eAAe;CACf,yBAAyB;CACzB,oBAAoB;CACpB,wCAAwC;KACpC,qCAAqC;KACrC,mCAAmC;KACnC,gCAAgC;AACrC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;AACA,6CAA6C;AAC7C;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB,IAAI,iCAAiC;IACrD,kBAAkB,EAAE,kDAAkD;IACtE,uBAAuB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["/* modified */\r\n.views-container {\r\n\tdisplay: table-cell;\r\n\tmax-width: 320px;\r\n\tmin-width: 320px;\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n\t.views-container {\r\n\t\tmax-width: 195px;\r\n\t\tmin-width: 195px;\r\n\t}\r\n}\r\n\r\n.views {\r\n\tposition: relative;\r\n\twidth: 100%; \r\n\tmargin-top: 48px;\r\n\tpadding: 0;\t\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\tborder-top: 1px solid #d5d5d5;\r\n\tborder-right: 1px solid #d5d5d5;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n} \r\n\r\n.views-options {\r\n\tmargin: 0 auto;\r\n\t/*padding: 0;*/\r\n\ttext-align: center;\r\n}\r\n\r\n.views-options > li{\r\n\tdisplay: inherit;\r\n\tmargin: 0;\r\n\tpadding: 0 10px !important;\r\n\tfont-size: 25px;\r\n\tlist-style: none;\r\n\ttext-align: center;\r\n\theight: 29px;\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n    .views-container {\r\n        max-width: 260px;\r\n        min-width: 260px;\r\n    }\r\n\r\n    .views-options li {\r\n        padding: 0 2px !important;\r\n    }\r\n}\r\n\r\n.views-options li a, .views-options li a .fa:not(.goalHelpItem) {\r\n\tcolor: #555 !important;\r\n\t-webkit-transition: color 300ms ease-out;\r\n\t    -moz-transition: color 300ms ease-out;\r\n\t    -o-transition: color 300ms ease-out;\r\n\t\ttransition: color 300ms ease-out;\r\n\t\tpadding: 0 !important;\t\r\n}\r\n\r\n.views-options li>a:hover,\r\n.views-options li>a:hover .fa,\r\n.views-options li>div a:hover,\r\n.views-options li>div a:hover .fa {\r\n\tcursor: pointer;\r\n\tcolor: #cc7929 !important;\r\n\ttext-decoration:none;\r\n\t-webkit-transition: color 300ms ease-out;\r\n\t    -moz-transition: color 300ms ease-out;\r\n\t    -o-transition: color 300ms ease-out;\r\n\t    transition: color 300ms ease-out;\r\n}\r\n\r\n.views-options li a.active, .views-options li a.active .fa {\r\n\tcolor: #cc7929 !important;\r\n}\r\n\r\n.views-options li a.active i {\r\n/*\ttext-shadow: 1px 1px 5px rgba(0,0,0,0.3);*/\r\n}\r\n\r\n\r\n.custom-autocomplete {\r\n    max-height: 100px;\r\n    overflow-y: auto;   /* prevent horizontal scrollbar */\r\n    overflow-x: hidden; /* add padding to account for vertical scrollbar */\r\n    z-index:1000 !important;\r\n}\r\n\r\n.custom-combobox {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.custom-combobox-toggle {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin-left: -1px;\r\n  padding: 0;\r\n}\r\n\r\n.custom-combobox-input {\r\n  margin: 0;\r\n  padding: 5px 10px;\r\n  width: 48px;\r\n}\t "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
